export const AUTH = {
  LOGIN: '/login',
  SELECT_ACCOUNT: '/select-account',
  SELECT_CATEGORY: '/select-category',
  SELECT_PAYMENT: '/select-payment',
  DOCUMENT_UPLOAD: '/document-upload',
  CREATE_BRANCH: '/create-branch',
  TERMS_AND_CONDITIONS: '/terms-and-conditions',
  PRIVACY_POLICY: '/privacy-policy',
  ACCEPT_INVITE: '/accept-invite',
  ORG_SELECTION: '/organization-selection'
};

export const HOME = '/';

export const BLANK_LAYOUT_ROUTES = {
  GROUP_CREATE: '/groups/create',
  GROUP_EDIT: '/groups/edit/:groupId',
  FORM_CREATE: '/forms/create',
  FORM_EDIT: '/forms/:formId/edit'
};

export const GROUPS = {
  HOME: '/groups',
  GROUP_INFO: '/groups/:groupId',
  ADD_MEMBER: '/groups/:groupId/add-members',
  EDIT_GROUP: '/groups/:groupId/edit'
};

export const BRANCHES = {
  HOME: '/branches',
  ADD_NEW_BRANCH: '/branches/add',
  EDIT_BRANCH: '/branches/edit',
  MANAGE_BANK_ACCOUNT: '/branches/manage-bank-account'
};

export const TEAM_MANAGEMENT = {
  TEAM_MANAGEMENT: '/team-management',
  INVITE_MEMBER: '/team-management/invite',
  EDIT_ROLE: '/team-management/edit-role/:userId'
};

export const LEAD_MANAGEMENT = {
  HOME: '/lead-management',
  LEAD_DASHBOARD: '/lead-management/dashboard',
  LEAD_LIST: '/lead-management/list',
  LEAD_ACTIVITIES: '/lead-management/my-activities',
  LEAD_ADD: '/lead-management/add',
  LEAD_SETTINGS: '/lead-management/settings',
  LEAD_REPORTS: '/lead-management/reports',
  LEAD_DETAILS: '/lead-management/details/:leadId',
  LEAD_EDIT: '/lead-management/edit/:leadId',
  LEAD_SOURCES: '/lead-management/sources',
  LEAD_AD_SOURCES: '/lead-management/sources/ad-sources',
  LEAD_AGENTS: '/lead-management/agents'
};

export const ADMIN = {
  KYC_DOCUMENTS: '/kyc-documents',
  ORGANIZATION_DETAILS: '/kyc-documents/organization/:orgId',
  INDIVIDUAL_DETAILS: '/kyc-documents/individual/:individualId',
  VIEW_DOCUMENTS: '/kyc-documents/organization/:orgId/documents',
  CUSTOMERS_LIST: '/customers-list',
  INDIVIDUAL_CUSTOMER_DETAILS: '/customers-list/individual/:individualId',
  ORGANIZATION_CUSTOMER_DETAILS: '/customers-list/organization/:orgId',
  CUTSOMER_DETAILS_VIEW: '/customers-list/customer-details/:organizationId'
};

export const PAGE_NOT_FOUND = '/page-not-found';

export const ADMIN_PAGE_NOT_FOUND = '/admin/page-not-found';

export const DOCS = {
  DOCS: '/docs',
  OVERVIEW: '/docs/overview',
  API_REFERENCE: '/docs/api-reference',
  API_KEYS: '/docs/configuration/api-keys',
  WEBHOOKS: '/docs/configuration/webhooks',
  CREATE_PAYMENT_ORDER: '/docs/api-reference/operations/create-payment-order',
  GET_PAYMENT_ORDER_BY_ORDER_ID:
    '/docs/api-reference/operations/get-payment-by-order-id',
  GET_PAYMENT_ORDER_BY_REFERENCE_ID:
    '/docs/api-reference/operations/get-payment-by-reference-id',
  CANCEL_PAYMENT_ORDER: '/docs/api-reference/operations/cancel-payment-order',
  CREATE_SETTLEMENT_ACCOUNT:
    '/docs/api-reference/operations/create-settlement-account',
  GET_SETTLEMENT_ACCOUNT_BY_REFERENCE_ID:
    '/docs/api-reference/operations/get-settlement-account-by-reference-id',
  PAYMENT_ORDER_REQUEST_SCHEMA:
    '/docs/api-reference/schemas/PaymentOrderRequest',
  PAYMENT_ORDER_RESPONSE_SCHEMA:
    '/docs/api-reference/schemas/PaymentOrderResponse',
  ERROR_RESPONSE_SCHEMA: '/docs/api-reference/schemas/ErrorResponse',
  SETTLEMENT_ACCOUNT_REQUEST_SCHEMA:
    '/docs/api-reference/schemas/SettlementAccountRequest',
  SETTLEMENT_ACCOUNT_RESPONSE_SCHEMA:
    '/docs/api-reference/schemas/SettlementAccountResponse',
  WEBHOOK_REFERENCE: '/docs/webhook-reference',
  WEBHOOK_PAYMENT: '/docs/webhook-reference/payment',
  WEBHOOK_ACCOUNT_SETTLEMENT: '/docs/webhook-reference/account-settlement'
};

export const HELP = '/help';

export const DASHBOARD = '/dashboard';

export const ORG_DASHBOARD = '/org-dashboard';

export const TRANSACTIONS = {
  TRANSACTIONS: '/transactions'
};

export const SUBSCRIPTIONS = {
  PLAN_DETAILS: '/subscription',
  NO_PLAN: '/subscription/no-plan'
};

export const ORG_SETTINGS = '/org-settings';

export const EXPENSE_TRACKER = {
  EXPENSE_DASHBOARD: '/expense-tracker/expense-dashboard',
  EXPENSE_LIST: '/expense-tracker/expense-list',
  REPORTS: '/expense-tracker/reports'
};

export const REPORTS = '/reports';

export const QUICK_COLLECT = {
  CREATE_LINK: '/quick-collect/create-link',
  SUCCESS: '/quick-collect/success'
};

export const MEMBERS = {
  MEMBERS: '/members',
  ADD_MEMBER: '/members/add',
  EDIT_MEMBER: '/members/edit/:memberId',
  MEMBER_DETAILS: '/members/:memberId'
};

export const EVENTS = {
  HOME: '/events',
  EVENT_DETAILS: '/events/:eventId',
  CREATE: '/events/create',
  EDIT: '/events/edit/:eventId',
  SUCCESS: '/events/success',
  ATTENDEE_DETAILS: '/events/:eventId/attendee/:attendeeId'
};

export const FORMS = {
  HOME: '/forms',
  CREATE: '/forms/create',
  EDIT: '/forms/:formId/edit',
  SUCCESS: '/forms/success',
  /** Single detail shell; tab content is switched inside FormDetailPage */
  DETAIL: '/forms/:formId'
};

/** Deep-link paths for the four FormDetailPage tabs (same page, not separate routes) */
export const FORM_DETAIL_TABS = {
  DASHBOARD: '/forms/:formId',
  REGISTRATIONS: '/forms/:formId/registrations',
  DROP_OFFS: '/forms/:formId/drop-offs',
  ACTIVITY: '/forms/:formId/activity'
};

export const TALLY_INTEGRATIONS = {
  TALLY_INTEGRATIONS: '/tally-integrations'
};
